// Lead Actions Sidebar Component
// Review, Contact, Convert checkboxes + Delete Lead

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import { Shield, Trash2, Loader2 } from 'lucide-react';

const LeadActions = ({ 
  intake, 
  updating, 
  deletingLead,
  showDeleteConfirm,
  setShowDeleteConfirm,
  onStatusUpdate,
  onDeleteLead
}) => {
  return (
    <Card className="border-slate-200" data-testid="lead-actions-card">
      <CardHeader>
        <CardTitle className="text-lg" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Actions
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center space-x-3">
          <Checkbox
            id="reviewed"
            checked={intake.reviewed}
            onCheckedChange={(checked) => onStatusUpdate('reviewed', checked)}
            disabled={updating}
            data-testid="reviewed-checkbox"
          />
          <Label htmlFor="reviewed" className="text-slate-700 cursor-pointer">
            Mark as Reviewed
          </Label>
        </div>
        <div className="flex items-center space-x-3">
          <Checkbox
            id="contacted"
            checked={intake.contacted}
            onCheckedChange={(checked) => onStatusUpdate('contacted', checked)}
            disabled={updating}
            data-testid="contacted-checkbox"
          />
          <Label htmlFor="contacted" className="text-slate-700 cursor-pointer">
            Mark as Contacted
          </Label>
        </div>
        <div className="flex items-center space-x-3">
          <Checkbox
            id="converted"
            checked={intake.converted}
            onCheckedChange={(checked) => onStatusUpdate('converted', checked)}
            disabled={updating}
            data-testid="converted-checkbox"
          />
          <Label htmlFor="converted" className="text-slate-700 cursor-pointer">
            Mark as Converted
          </Label>
        </div>
        
        {/* GDPR/CCPA Delete Lead */}
        <Separator className="my-4" />
        <div className="space-y-2">
          <p className="text-xs text-slate-500 uppercase tracking-wide flex items-center gap-1">
            <Shield className="w-3 h-3" />
            Data Privacy (CCPA/GDPR)
          </p>
          {!showDeleteConfirm ? (
            <Button
              variant="outline"
              className="w-full text-red-600 border-red-200 hover:bg-red-50 hover:border-red-300"
              onClick={() => setShowDeleteConfirm(true)}
              data-testid="delete-lead-btn"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Delete Lead Data
            </Button>
          ) : (
            <div className="p-3 bg-red-50 rounded-lg border border-red-200 space-y-3">
              <p className="text-sm text-red-800">
                <strong>Are you sure?</strong> This will permanently delete all data for this lead, including follow-ups and consultation records. This action cannot be undone.
              </p>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  className="flex-1"
                  onClick={() => setShowDeleteConfirm(false)}
                  disabled={deletingLead}
                >
                  Cancel
                </Button>
                <Button
                  variant="destructive"
                  size="sm"
                  className="flex-1"
                  onClick={onDeleteLead}
                  disabled={deletingLead}
                  data-testid="confirm-delete-btn"
                >
                  {deletingLead ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    'Delete Permanently'
                  )}
                </Button>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default LeadActions;
